// extracted by mini-css-extract-plugin
module.exports = {"link":"BuyNowCta_link__Bym4t","nui-active":"BuyNowCta_nui-active__3geiZ"};